export default __webpack_public_path__ + "static/media/taxi_icon.d8c1146f.png";